module.exports = __webpack_public_path__ + "static/img/宏翔东方高企证书.21eb0c6a.jpg";